<template>
    <div class="page-master">
        
        <h1>首页</h1>
        
    </div>
</template>
<script>
import store from '@/store'
import JRGLOBAL from '@/api/jrglobal'
import { mapActions } from 'vuex'
import { required } from 'vuelidate/lib/validators'
export default {
  name: 'Home',
  deactivated(){
    if(store.getters.closePageNames==this.$options.name){
        this.$destroy(this.$options.name)
    }
  },
  //输入校验
  validations: {
    input: {
      required
    }
  },
  data () {
    return {
        input: '123',
        display: true,
        btype: true,
        checkek: true,
        cmValue: {
          paramValue: '',
          paramLike: '==',
          paramName: ''
        },
        columns: [
          {prop: 'date', label: '日期', width: 120, showOverflowTooltip: true},
          {prop: 'address', label: '地址', width: 100, showOverflowTooltip: true},
          {prop: 'address', label: '噜噜噜', width: 230, showOverflowTooltip: true},
          {prop: 'address', label: '娃哈哈', width: 100, showOverflowTooltip: true},
          {prop: 'address', label: '地址', width: 100, showOverflowTooltip: true},
          {prop: 'address', label: '挖挖掘机挖掘机挖掘机掘机', width: 100},
          {prop: 'address', label: '娃哈哈', width: 100, showOverflowTooltip: true},
          {prop: 'address', label: '娃哈哈', width: 100, showOverflowTooltip: true},
          {prop: 'address', label: '噜噜噜', width: 230, showOverflowTooltip: true},
          {prop: 'address', label: '娃哈哈', width: 100, showOverflowTooltip: true},
          {prop: 'address', label: '地址', width: 100, showOverflowTooltip: true},
          {prop: 'address', label: '挖挖掘机挖掘机挖掘机掘机', width: 100},
          {prop: 'address', label: '娃哈哈', width: 100, showOverflowTooltip: true},
          {prop: 'address', label: '娃哈哈', width: 100, showOverflowTooltip: true},
          {prop: 'address', label: '噜噜噜', width: 230, showOverflowTooltip: true},
          {prop: 'address', label: '娃哈哈', width: 100, showOverflowTooltip: true}
        ],
        columnst: [
          {prop: 'date', label: '日期', width: 120},
          {prop: 'address', label: '地址', width: 100, showOverflowTooltip: true}
        ],
        columnst2: [
          {prop: 'date', label: '日期', width: 120},
          {prop: 'address', label: '地址', width: 100, showOverflowTooltip: true},          
          {prop: 'address', label: '噜噜噜', width: 230, showOverflowTooltip: true},
          {prop: 'address', label: '娃哈哈', width: 100, showOverflowTooltip: true}
        ],
        columns2: Array.from({ length: 500 }, (_, idx) => ({
          prop: 'address', label: '地址' + idx, width: 200, showOverflow: true, sortable: true, fixed: ''
        })),
        data: {
          tableData:Array.from({ length: 10000 }, (_, idx) => ({
            id: idx + 1,
            date: '2016-05-03',
            name: 1,
            ab: '欢迎使用pl-table',
            address: 1 + idx
          }))
        },
        test: {}
    }
  },
  created() {
    // this.getStationMapping()
  },
  methods: {
    // ...mapActions([     
    //   'getStationMapping'
    // ]),
    cellstyle({row, column, rowIndex, columnIndex}) {
      // console.log(row)
      // console.log(column)
      // console.log(rowIndex)
      // console.log(columnIndex)
      if(columnIndex==1 && rowIndex==1){
      //   console.log(row)
      // console.log(column)
      // console.log(rowIndex)
        return 'cellstyle'
      }
    },
      demo(id,e) {
        this.btype = e
        console.log(id)
        console.log(e)
      },
      testt() {
        // var tt = {}
        // tt.pageSize = 100
        // tt.pageNumber = 3
        // var ql = {}
        // ql.order ='user'
        // ql.des = 'asc'
        // tt.queryLimit= ql

        // var parma = {}
        // parma.value='zhangsna'
        // parma.like="=="
        // var parma2 = {}
        // parma2.value='lisi'
        // parma2.like="%%"

        // var parmaMap = {}
        // parmaMap.userName = parma
        // parmaMap.userId = parma2
        // tt.parmaMap = parmaMap

        // console.log(JSON.stringify(tt))

        var a = {"a":111,"b":222}
        console.log(a['a'])
        console.log(JRGLOBAL.likeType[3])
      },
      set() {
        this.columns = this.columnst2
        this.$refs.plTable.doLayout()
      },
      test2() {
        // var maps = new Map(store.getters.stationMapping)

        // console.log(maps)
        // console.log(maps.size)
        // console.log(maps.get('ST0000000000004'))

        let obj1 = {a:1}, obj2 = {b:2,c:3}; 
            const map = new Map([
                ['name','张三'],
                ['age',22],
                ['sex','男'],
                [obj1,'今天天气好'],
                [[1,2],'哈哈哈'],
                ['age',55],
                ['obj2',obj2]
            ]); 
            console.log(map);
            console.log(map.size);//5 也可以用来去重
            console.log(map.get('obj2'))
            map.get('obj2').b = 3
            // let obj3 = map.get('obj2')
            // obj3.b = 3
            // map.set('obj2',obj3)
            console.log(map.get('obj2'))
      }
  }
}
</script>
<style scoped lang="scss">
    .ccc{
      position:absolute;
      right:-4px;
      top: -10px; 
    }
    .expor{
      position:absolute;
      left: 0px;
      bottom: 0px; 
    }
    

</style>


// WEBPACK FOOTER //
// src/views/Home.vue